<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="text-center text-primary my-2" v-if="loading">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
            <form
              v-if="!loading"
              @submit.prevent="onSubmit"
              novalidate
              enctype="multipart/form-data"
              :class="
                submitted
                  ? 'needs-validation was-validated'
                  : 'needs-validation'
              "
            >
              <input
                type="hidden"
                name="csrfmiddlewaretoken"
                value="DZdEYxUPT2VHc5ZcJYfl4a1Mx0j7o6liciskdv6QxfkIQAqi9h3UBGxDwerRS5yu"
              />

              <p></p>
              <h5 class="font-size-14">GENERAL</h5>
              <p></p>

              <div class="row">
                <div class="col-lg-6">
                  <label for="job_title">Title*</label>
                  <v-select
                    v-model.trim="$v.person_title.$model"
                    :options="titleList"
                  ></v-select>
                  <div
                    v-if="submitted && !$v.person_title.required"
                    class="invalid-tooltip"
                  >
                    This field is required
                  </div>
                </div>

                <div class="col-lg-6">
                  <label for="first_name_id">First Name*</label>
                  <input
                    type="text"
                    name="first_name"
                    id="first_name_id"
                    class="form-control"
                    maxlength="255"
                    required=""
                    v-model.trim="$v.first_name.$model"
                  />
                  <div
                    v-if="submitted && !$v.first_name.required"
                    class="invalid-tooltip"
                  >
                    This field is required
                  </div>
                </div>
              </div>
              <p></p>

              <div class="row">
                <div class="col-lg-6">
                  <label for="last_name_id">Last Name*</label>
                  <input
                    type="text"
                    name="last_name"
                    id="last_name_id"
                    class="form-control"
                    maxlength="255"
                    required=""
                    v-model.trim="$v.last_name.$model"
                  />
                  <div
                    v-if="submitted && !$v.last_name.required"
                    class="invalid-tooltip"
                  >
                    This field is required
                  </div>
                </div>

                <div class="col-lg-6">
                  <label for="middle_name_id">Middle Name</label>
                  <input
                    type="text"
                    name="middle_name"
                    id="middle_name_id"
                    class="form-control"
                    maxlength="255"
                    v-model.trim="middle_name"
                  />
                </div>
              </div>
              <p></p>

              <div class="row">
                <div class="col-lg-6">
                  <label for="gender_id">Gender</label>
                  <select
                    name="gender"
                    id="gender_id"
                    class="form-select"
                    v-model.trim="gender"
                  >
                    <option value="male" selected="">Male</option>

                    <option value="female">Female</option>
                  </select>
                </div>

                <div class="col-lg-6">
                  <label for="date_of_birth_id">Date of Birth</label>
                  <input
                    type="date"
                    name="date_of_birth"
                    id="date_of_birth_id"
                    class="form-control"
                    v-model.trim="date_of_birth"
                  />
                </div>
              </div>
              <p></p>

              <div class="row">
                <div class="col-lg-6">
                  <label for="address_id">Personal Address</label>
                  <input
                    type="text"
                    name="address"
                    id="address_id"
                    v-model.trim="address"
                    class="form-control"
                  />
                </div>

                <div class="col-lg-6">
                  <label for="personal_mobile">Personal Mobile</label>
                  <input
                    type="text"
                    name="personal_mobile"
                    id="personal_mobile"
                    v-model.trim="$v.personal_mobile.$model"
                    class="form-control"
                    placeholder="999-999-9999"
                    v-mask="'###-###-####'"
                  />
                  <div
                    v-if="submitted && !$v.personal_mobile.customPhoneValidate"
                    class="invalid-tooltip"
                  >
                    You should provide a phone number (###-###-####)
                  </div>
                </div>

                <!-- <div class="col-lg-6">
                  <div class="row">

                    <div class="col-12 col-lg-4">
                      <label for="ext">Ext</label>
                      <input
                        type="text"
                        name="ext"
                        id="ext"
                        class="form-control"
                        v-model.trim="ext"
                      />
                    </div>
                  </div>
                </div> -->
              </div>
              <p></p>

              <div class="row">
                <div class="col-lg-6">
                  <label for="personal_email">Personal Email</label>
                  <input
                    type="text"
                    name="personal_email"
                    id="personal_email"
                    v-model.trim="personal_email"
                    class="form-control"
                  />
                </div>

                <div class="col-lg-6">
                  <label for="linkedin_url">LinkedIn URL</label>
                  <input
                    type="text"
                    name="linkedin_url"
                    id="linkedin_url"
                    v-model.trim="$v.linkedin_url.$model"
                    class="form-control"
                  />
                  <div
                    v-if="submitted && !$v.linkedin_url.url"
                    class="invalid-tooltip"
                  >
                    You should provide a valid url.
                  </div>
                </div>
              </div>
              <p></p>

              <template v-if="$route.query.org_id && organization[0]">
                <p></p>
                <h5 class="font-size-14">ORGANIZATION</h5>
                <p></p>

                <div class="row">
                  <div class="col-lg-6">
                    <label for="organization_id">Organization*</label>
                    <input
                      type="text"
                      disabled
                      class="form-control"
                      :value="organization[0].name"
                    />
                    <!-- <v-select
                      v-model.trim="$v.organization.$model"
                      :options="organizationList"
                    ></v-select> -->
                  </div>
                  <div class="col-lg-3">
                    <label for="employment_status_id">Employment Status*</label>
                    <select
                      name="employment_status"
                      id="employment_status_id"
                      class="form-select"
                      v-model="employment_status"
                    >
                      <option value="active">Active</option>

                      <option value="expired">Expired</option>
                    </select>
                  </div>
                  <div class="col-lg-3">
                    <label for="job_title_id">Job Title</label>
                    <input
                      type="text"
                      name="job_title"
                      id="job_title_id"
                      class="form-control"
                      maxlength="255"
                      v-model.trim="$v.job_title.$model"
                    />
                  </div>
                </div>

                <p></p>

                <div class="row">
                  <div class="col-lg-4">
                    <label for="email_id">Work Email</label>
                    <input
                      type="email"
                      name="email"
                      id="email_id"
                      class="form-control"
                      v-model.trim="$v.email.$model"
                    />
                  </div>
                  <div class="col-lg-4">
                    <label for="mobile_phone_id">Work Mobile Phone</label>
                    <input
                      type="text"
                      name="mobile_phone"
                      id="phone_number_id"
                      v-model.trim="$v.mobile_phone.$model"
                      class="form-control"
                      placeholder="999-999-9999"
                      v-mask="'###-###-####'"
                    />
                    <div
                      v-if="submitted && !$v.mobile_phone.customPhoneValidate"
                      class="invalid-tooltip"
                    >
                      You should provide a phone number (###-###-####)
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <label for="office_phone_id">Work Office Phone</label>
                    <input
                      type="text"
                      name="office_phone"
                      id="office_phone_id"
                      v-model.trim="$v.office_phone.$model"
                      class="form-control"
                      placeholder="999-999-9999"
                      v-mask="'###-###-####'"
                    />
                    <div
                      v-if="submitted && !$v.office_phone.customPhoneValidate"
                      class="invalid-tooltip"
                    >
                      You should provide a phone number (###-###-####)
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-4">
                    <label for="ice_handle">ICE Handle</label>
                    <input
                      type="text"
                      name="ice_handle"
                      id="ice_handle"
                      v-model.trim="ice_handle"
                      class="form-control"
                    />
                  </div>

                  <div class="col-lg-4">
                    <label for="teams_handle">Teams Handle</label>
                    <input
                      type="text"
                      name="teams_handle"
                      id="teams_handle"
                      v-model.trim="teams_handle"
                      class="form-control"
                    />
                  </div>

                  <div class="col-lg-4">
                    <label for="Salutation">Salutation</label>
                    <input
                      type="text"
                      name="salutation"
                      id="Salutation"
                      v-model.trim="salutation"
                      class="form-control"
                    />
                  </div>
                </div>
                <p></p>

                <h5 class="font-size-14 mt-5">CONTACT PREFERENCES</h5>
                <p></p>

                <div class="row">
                  <div class="col-lg-6">
                    <label for="job_title_id"
                      >Preferred Time of Day for Calls</label
                    >
                    <input
                      type="text"
                      name="job_title"
                      id="job_title_id"
                      class="form-control"
                      v-model.trim="prefered_time_of_day_calls"
                    />
                  </div>
                  <div class="col-lg-6">
                    <label for="prefered_time_of_day_emails"
                      >Preferred Time of Day for Emails</label
                    >
                    <input
                      type="text"
                      name="prefered_time_of_day_emails"
                      id="prefered_time_of_day_emails"
                      class="form-control"
                      v-model.trim="prefered_time_of_day_emails"
                    />
                  </div>
                </div>
                <p></p>

                <div class="row">
                  <div class="col-lg-6">
                    <label for="prefered_day_of_week_calls"
                      >Preferred Day of Week for Calls</label
                    >
                    <input
                      type="text"
                      name="prefered_day_of_week_calls"
                      id="prefered_day_of_week_calls"
                      class="form-control"
                      v-model.trim="prefered_day_of_week_calls"
                    />
                  </div>
                  <div class="col-lg-6">
                    <label for="prefered_day_of_week_emails"
                      >Preferred Day of Week for Emails</label
                    >
                    <input
                      type="text"
                      name="prefered_day_of_week_emails"
                      id="prefered_day_of_week_emails"
                      class="form-control"
                      v-model.trim="prefered_day_of_week_emails"
                    />
                  </div>
                </div>
                <p></p>

                <div class="row">
                  <div class="col-lg-6">
                    <label for="prefered_checkin_frequency"
                      >Preferred Check-in Frequency</label
                    >
                    <input
                      type="text"
                      name="prefered_checkin_frequency"
                      id="prefered_checkin_frequency"
                      class="form-control"
                      v-model.trim="prefered_checkin_frequency"
                    />
                  </div>
                </div>
                <p></p>
              </template>

              <p></p>
              <h5 class="font-size-14">Files</h5>
              <p></p>

              <div class="row">
                <div class="col-lg-12">
                  <div class="drag-area">
                    <div>
                      <div
                        :class="['dropZone', dragging ? 'dropZone-over' : '']"
                        @dragenter="dragging = true"
                        @dragleave="dragging = false"
                      >
                        <div class="dropZone-info" @drag="onChange">
                          <span
                            style="
                              font-size: 21pt;
                              margin-bottom: 15px;
                              color: #bebebe;
                            "
                            class="fas fa-cloud-upload-alt dropZone-title"
                          ></span>
                          <span class="dropZone-title"
                            >Drag and drop files here</span
                          >
                          <span> Or </span>
                          <button
                            type="button"
                            class="
                              btn btn-primary btn-sm btn-task
                              mb-3
                              mt-3
                              removeFile
                            "
                            @click="fileInput.click()"
                          >
                            Browse files
                          </button>
                          <div class="dropZone-upload-limit-info">
                            <div>extension support: *</div>
                            <div>maximum file size: 5 MB</div>
                          </div>
                        </div>
                        <input
                          refs="fileInput"
                          type="file"
                          @change="onChange"
                          multiple
                        />
                      </div>
                    </div>
                  </div>

                  <template v-if="fileBeforeUpload">
                    <p></p>
                    <div
                      v-for="(fileData, index) in fileBeforeUpload"
                      :key="index"
                      class="file-list-item"
                    >
                      <a :href="fileData.file" target="_blank">
                        {{ fileData.name }}
                      </a>
                      <button
                        class="btn btn-link text-danger text-gradient px-3 mb-0"
                        :disabled="loadingAction"
                        type="button"
                        @click="deleteFileBeforeUpload(fileData)"
                      >
                        <i class="far fa-trash-alt me-2" aria-hidden="true"></i
                        >Delete
                      </button>
                    </div>
                  </template>
                </div>
              </div>

              <template v-if="files">
                <div
                  v-for="(fileData, index) in files"
                  :key="index"
                  class="file-list-item"
                >
                  <a :href="fileData.file" target="_blank">
                    {{ fileData.filename }}
                  </a>

                  <button
                    class="btn btn-link text-danger text-gradient px-3 mb-0"
                    :disabled="loadingAction"
                    type="button"
                    @click="deleteFile(fileData)"
                  >
                    <i class="far fa-trash-alt me-2" aria-hidden="true"></i
                    >Delete
                  </button>
                </div>
              </template>

              <p></p>
              <!-- Start Button -->
              <div class="d-flex flex-wrap gap-2">
                <button
                  class="btn btn-success"
                  :disabled="loadingAction"
                  type="submit"
                >
                  Save
                </button>
                <button
                  type="button"
                  class="btn btn-light waves-effect"
                  @click="$router.go(-1)"
                >
                  <!-- <router-link
                    :to="'/mpg/contacts/' + $route.params.id + '/details'"
                    ></router-link
                  > -->
                  Cancel
                </button>
              </div>
              <!-- End Button -->
            </form>
            <!-- End Form -->
          </div>
          <!-- End Card Body -->
        </div>
        <!-- End Card -->
      </div>
      <!-- End Col -->
    </div>
  </div>
</template>

<script>
import { organizationsService } from '../services/organizations.service'
import { contactsService } from '../services/contacts.service'
import { required, email, url } from 'vuelidate/lib/validators'
import { router } from '../router'
import { customPhoneValidate } from '../helpers'
import { authenticationService } from '../services/authentication.service'

export default {
  name: 'EditContacts',
  components: {},
  data () {
    return {
      titleList: [
        { label: '---------', code: '' },
        { label: 'Dr', code: 'doctor' },
        { label: 'Mr', code: 'mr' },
        { label: 'Ms', code: 'ms' },
        { label: 'Mrs', code: 'mrs' },
        { label: 'Miss', code: 'miss' },
        { label: 'Professor', code: 'professor' },
        { label: 'Sir', code: 'sir' }
      ],
      organizationList: [],
      first_name: '',
      last_name: '',
      middle_name: '',
      personal_mobile: '',
      personal_mobile_raw: '',
      date_of_birth: '',
      job_title: '',
      email: '',
      mobile_phone: '',
      mobile_phone_raw: '',
      office_phone: '',
      office_phone_raw: '',
      person_title: '',
      organization: '',
      submitted: false,
      loading: false,
      loadingAction: false,
      error: '',
      department: '',
      salutation: '',
      gender: '',
      address: '',
      personal_email: '',
      linkedin_url: '',
      prefered_time_of_day_calls: '',
      prefered_time_of_day_emails: '',
      prefered_day_of_week_calls: '',
      prefered_day_of_week_emails: '',
      prefered_checkin_frequency: '',
      ice_handle: '',
      teams_handle: '',
      employment_status: 'active',
      organization_contact_id: null,
      files: [],
      fileBeforeUpload: [],
      dragging: false
    }
  },
  validations: {
    person_title: { required },
    first_name: { required },
    last_name: { required },
    organization: {},
    email: { email },
    personal_email: { email },
    job_title: {},
    linkedin_url: { url },
    mobile_phone: { customPhoneValidate },
    personal_mobile: { customPhoneValidate },
    office_phone: { customPhoneValidate }
  },
  computed: {},
  created () {
    if (!this.$route.params.id || this.$route.params.id === '') {
      router.push('/mpg/contacts/')
    }
    this.loading = true
    contactsService
      .getFileFile('contact-' + this.$route.params.id)
      .then((files) => {
        this.files = files.results
      })
    organizationsService
      .getData({
        q: '',
        limit: '99999999',
        ordering: '',
        offset: 0,
        expands: ''
      })
      .then((rs) => {
        this.organizationList = rs.results.map((e) => {
          e.label = e.name
          e.code = e.organization_id
          if (
            this.$route.query.org_id &&
            e.organization_id.toString() === this.$route.query.org_id
          ) {
            this.organization = []
            this.organization.push(e)
          }
          return e
        })

        contactsService.getDataById(this.$route.params.id).then((contact) => {
          let currentCompany = null
          currentCompany = contact.organizations_contacts.find(
            (e) =>
              e.organization.organization_id.toString() ===
              this.$route.query.org_id
          )

          this.first_name = contact.first_name
          this.last_name = contact.last_name
          this.middle_name = contact.middle_name
          this.personal_mobile = contact.personal_mobile
          this.date_of_birth = contact.date_of_birth
          this.gender = contact.gender

          this.address = contact.personal_address
          this.personal_email = contact.personal_email
          this.linkedin_url = contact.linkedin_url

          if (currentCompany) {
            this.prefered_time_of_day_calls =
              currentCompany.prefered_time_day_calls
            this.prefered_time_of_day_emails =
              currentCompany.prefered_time_day_emails
            this.prefered_day_of_week_calls =
              currentCompany.prefered_time_week_day_calls
            this.prefered_day_of_week_emails =
              currentCompany.prefered_time_week_day_emails
            this.prefered_checkin_frequency =
              currentCompany.prefered_checkin_frequency
            this.salutation = currentCompany.salutation
            this.ice_handle = currentCompany.ice_handle
            this.teams_handle = currentCompany.teams_handle
            this.email = currentCompany.email
            this.mobile_phone = currentCompany.mobile_phone
            this.office_phone = currentCompany.office_phone
            this.job_title = currentCompany.job_title
            this.employment_status = currentCompany.employment_status
            this.organization_contact_id =
              currentCompany.organization_contact_id
          }
          this.person_title = this.titleList.find(
            (e) => e.code === contact.title
          )

          this.salutation = contact.salutation
          this.department = contact.department
          this.loading = false
        })
      })
  },
  methods: {
    updatePhoneMobile (event) {
      this.mobile_phone_raw = event
    },
    updatePhoneOffice (event) {
      this.office_phone_raw = event
    },
    updatePhone (event) {
      this.personal_mobile_raw = event
    },
    onSubmit () {
      this.submitted = true

      // stop here if form is invalid
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      //
      this.loadingAction = true
      let payload = {
        first_name: this.first_name,
        last_name: this.last_name,
        middle_name: this.middle_name,
        title: this.person_title.code,
        personal_address: this.address,
        personal_email: this.personal_email,
        linkedin_url: this.linkedin_url,
        personal_mobile: this.personal_mobile,
        gender: this.gender
      }

      payload = Object.fromEntries(
        Object.entries(payload).filter(([_, v]) => v != null && v !== '')
      )

      if (this.date_of_birth) {
        payload.date_of_birth = this.date_of_birth
      }
      if (this.$route.query.org_id && this.organization_contact_id) {
        contactsService
          .updateOrgToContact(
            {
              employment_status: this.employment_status,
              work_mobile: this.mobile_phone,
              job_title: this.job_title,
              work_email: this.email,
              work_office_phone: this.office_phone,
              department: this.department,
              ice_handle: this.ice_handle,
              teams_handle: this.teams_handle,
              salutation: this.salutation,
              prefered_time_day_calls: this.prefered_time_of_day_calls,
              prefered_time_day_emails: this.prefered_time_of_day_emails,
              prefered_time_week_day_calls: this.prefered_day_of_week_calls,
              prefered_time_week_day_emails: this.prefered_day_of_week_emails,
              prefered_checkin_frequency: this.prefered_checkin_frequency
            },
            this.organization_contact_id
          )
          .then((data) => {
            if (this.fileBeforeUpload.length > 0) {
              const type = authenticationService.currentContentTypeValue
              const contentType = type.find((e) => e.model === 'file').id
              this.loadingAction = true
              const promise = []
              for (let i = 0; i < this.fileBeforeUpload.length; i++) {
                let formData = new FormData()
                formData.append('file', this.fileBeforeUpload[i])
                formData.append('filename', this.fileBeforeUpload[i].name)
                formData.append(
                  'object_id',
                  'contact-' + this.$route.params.id
                )
                formData.append('content_type', contentType)
                promise.push(
                  contactsService.uploadFile(formData).then(
                    (rs) => {
                      return rs
                    },
                    (error) => {
                      this.$bvToast.toast('Error.', {
                        title: `Error. Cannot Upload File ${error}`,
                        variant: 'danger',
                        solid: true
                      })
                    }
                  )
                )
              }
              Promise.all(promise).then((values) => {
                this.$nextTick(() => {
                  setTimeout(() => {
                    contactsService
                      .getFileFile('contact-' + this.$route.params.id)
                      .then((files) => {
                        this.files = files.results
                        this.loadingAction = false
                        this.fileBeforeUpload = []
                      })
                  }, 100)
                })
              })
            } else {
              this.loadingAction = false
            }
            contactsService.update(payload, this.$route.params.id).then(
              (rs) => {
                this.$nextTick(() => {
                  this.$router.go(-1)
                  // router.push('/mpg/contacts/')
                })
              },
              (error) => {
                this.$bvToast.toast('Cannot update the contact.', {
                  title: `Error`,
                  variant: 'danger'
                })
                this.error = error
                this.loadingAction = false
              }
            )
          })
      } else {
        if (this.fileBeforeUpload.length > 0) {
          const type = authenticationService.currentContentTypeValue
          const contentType = type.find((e) => e.model === 'file').id
          this.loadingAction = true
          const promise = []
          for (let i = 0; i < this.fileBeforeUpload.length; i++) {
            let formData = new FormData()
            formData.append('file', this.fileBeforeUpload[i])
            formData.append('filename', this.fileBeforeUpload[i].name)
            formData.append('object_id', 'contact-' + this.$route.params.id)
            formData.append('content_type', contentType)
            promise.push(
              contactsService.uploadFile(formData).then(
                (rs) => {
                  return rs
                },
                (error) => {
                  this.$bvToast.toast('Error.', {
                    title: `Error. Cannot Upload File ${error}`,
                    variant: 'danger',
                    solid: true
                  })
                }
              )
            )
          }
          Promise.all(promise).then((values) => {
            this.$nextTick(() => {
              setTimeout(() => {
                contactsService
                  .getFileFile('contact-' + this.$route.params.id)
                  .then((files) => {
                    this.files = files.results
                    this.loadingAction = false
                    this.fileBeforeUpload = []
                  })
              }, 100)
            })
          })
        } else {
          this.loadingAction = false
        }
        contactsService.update(payload, this.$route.params.id).then(
          (rs) => {
            this.$nextTick(() => {
              this.$router.go(-1)
              // router.push('/mpg/contacts/')
            })
          },
          (error) => {
            this.$bvToast.toast('Cannot update the contact.', {
              title: `Error`,
              variant: 'danger'
            })
            this.error = error
            this.loadingAction = false
          }
        )
      }
    },

    deleteFile (file) {
      this.loadingAction = true
      contactsService
        .deleteFile(file.file_id)
        .then((rs) => {
          this.loadingAction = false
          this.$bvToast.toast('Delete successfully.', {
            title: `Update`,
            variant: 'primary',
            solid: true
          })
          this.files = this.files.filter((e) => e.file_id !== file.file_id)
          this.loadingAction = false
        })
        .catch(() => {
          this.$bvToast.toast('Cannot delete this file.', {
            title: `Error`,
            variant: 'danger',
            solid: true
          })
        })
    },

    onChange (e) {
      var files = e.target.files || e.dataTransfer.files

      if (!files.length) {
        this.dragging = false
        return
      }

      this.createFile(files)
    },

    createFile (files) {
      const inValidFile = []

      for (let i = 0; i < files.length; i++) {
        if (files[i].size > 5000000) {
          inValidFile.push(files[i])
        }
      }

      if (inValidFile.length > 0) {
        this.$bvToast.toast('Error.', {
          title: `Please check file size no over 5 MB.`,
          variant: 'danger',
          solid: true
        })
        this.dragging = false
        return
      }

      this.fileBeforeUpload = [...this.fileBeforeUpload, ...files]
      this.dragging = false
    },

    deleteFileBeforeUpload (fileData) {
      this.fileBeforeUpload = this.fileBeforeUpload.filter(
        (e) => e.name !== fileData.name
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/EditContacts.vue